
















































import { Component } from 'vue-property-decorator';
import { SimpleForm, DataModule } from 'wax-lib';
import { WxDataTable, WxDataDialog, WxTextWidget, WxFabButton } from 'wax-lib';
import { MobileDeviceDesc } from './mobiledevice';
import store from '@/main-store';
import { WxRequest as request } from 'wax-lib';

@Component({
    components: { itkDataTable: WxDataTable, itkDataDialog: WxDataDialog, itkText: WxTextWidget, itkFabButton: WxFabButton },
})
export default class Registry extends SimpleForm {
    constructor() {
        super(new DataModule(store, new MobileDeviceDesc('regconfigmobiledevice', 'mobiledevice')));
    }

    // actions
    protected hndlSelect() {
        super.hndlSelect();
    }

    protected async hndlUpdate(item: object, isInsert: boolean) {
        super.hndlUpdate(item, isInsert);
    }

    protected async hndlDelete(item: object) {
        super.hndlDelete(item);
    }

    protected async hndlReset(item: object) {
        const confirm = String(this.$t('$module.registry.RESET_ITEM', [this.dataSet.recordDesc]));
        const rc = await this.$confirm(confirm, {
            title: this.$t('$module.registry.RESET_CONFIRMATION'),
            buttonTrueText: this.$t('$common.OKAY'),
            buttonFalseText: this.$t('$common.CANCEL'),
            color: 'warn',
            icon: 'warn',
            width: 350,
        });

        if (rc) {
            //await this.dataModule.deleteMaster(item, this.$i18n);
            this.dataModule.dataLoading = true;
            const res = await request().execute('RegResetMobileDevice', { DEVICEGUID: (item as any).GUID });
            this.dataModule.dataLoading = false;
            const success = !!res.data && res.data instanceof Array && res.data.length === 1;
            if (success) {
                this.dataSet.insertOrUpdate(res.data[0], false, this.$i18n);
                if (this.$store) {
                    this.$store.commit('addMessage', this.dataSet.message, { root: true });
                }
            }
            return success;
        }
    }

    protected hndlConfigWidget(widget: any) {
        super.hndlConfigWidget(widget);
    }

    // announceDialog Functions
    private isIMEIValid(imei: string) {
        if (!/^[0-9]{15}$/.test(imei)) {
            return false;
        }

        let sum = 0;
        let factor = 2;
        let checkDigit;
        let multipliedDigit;

        for (let i = 13, li = 0; i >= li; i--) {
            multipliedDigit = parseInt(imei.charAt(i), 10) * factor;
            sum += multipliedDigit >= 10 ? (multipliedDigit % 10) + 1 : multipliedDigit;
            factor === 1 ? factor++ : factor--;
        }
        checkDigit = (10 - (sum % 10)) % 10;

        return !(checkDigit !== parseInt(imei.charAt(14), 10));
    }
}
